import React, { memo, useMemo } from "react";
import { Card, Descriptions, Row, Col } from "antd";
import { ShipmentStatus } from "@/utils/enum";
import { formatPhoneNumber } from "@/utils/utils";

// Inline styles
const rowStyle = { gutter: [16, 16], justify: "space-between" };
const cardStyle = {
  style: { height: "100%" },
  headStyle: { color: "white", backgroundColor: "#22316C" },
};
const grid = { md: { span: 12 }, sm: { span: 24 } };

const TransporterDetails = memo(({ shipmentStatus, dropOffAddress, pickupAddress }) => {
  const hideInfo = useMemo(() => shipmentStatus < ShipmentStatus.Assigned, [shipmentStatus]);

  if (!pickupAddress || !dropOffAddress) return null;

  return (
    <>
      <Row gutter={rowStyle.gutter} justify={rowStyle.justify} style={{ marginBottom: 16 }}>
        <Col md={{ span: grid.md.span }} sm={{ span: grid.sm.span }}>
          <Card
            type="inner"
            title="Pickup Location"
            style={cardStyle.style}
            headStyle={cardStyle.headStyle}
            className="noLeftMarginCard"
          >
            {hideInfo ? (
              <p style={{ marginBottom: 0 }}>
                {pickupAddress?.simplifyAddress} {pickupAddress?.zipCode}
              </p>
            ) : (
              <Descriptions title={pickupAddress?.name ?? "N/A"} column={1}>
                <Descriptions.Item
                  key="pickupAddress"
                  style={{
                    paddingBottom: "0",
                  }}
                >
                  <p>{pickupAddress.completedAddress ?? "N/A"}</p>
                </Descriptions.Item>
                <Descriptions.Item
                  key="pickupName"
                  label="Contact"
                  style={{
                    paddingBottom: "0",
                  }}
                >
                  {pickupAddress.contactName}
                </Descriptions.Item>
                <Descriptions.Item
                  key="pickupPhone"
                  label="Phone"
                  style={{
                    paddingBottom: "0",
                  }}
                >
                  {formatPhoneNumber(pickupAddress.contactPhone)}
                </Descriptions.Item>
              </Descriptions>
            )}
          </Card>
        </Col>
        <Col md={{ span: grid.md.span }} sm={{ span: grid.sm.span }}>
          <Card
            type="inner"
            title="Drop-off Location"
            style={cardStyle.style}
            headStyle={cardStyle.headStyle}
            className="noLeftMarginCard"
          >
            {hideInfo ? (
              <p style={{ marginBottom: 0 }}>
                {dropOffAddress?.simplifyAddress} {dropOffAddress?.zipCode}
              </p>
            ) : (
              <Descriptions title={dropOffAddress.name ?? "N/A"} column={1}>
                <Descriptions.Item
                  key="dropOffAddress"
                  style={{
                    paddingBottom: "0",
                  }}
                >
                  <p>{dropOffAddress.completedAddress ?? "N/A"}</p>
                </Descriptions.Item>
                <Descriptions.Item
                  key="dropOffName"
                  label="Contact"
                  style={{
                    paddingBottom: "0",
                  }}
                >
                  {dropOffAddress.contactName}
                </Descriptions.Item>
                <Descriptions.Item
                  key="dropOffPhone"
                  label="Phone"
                  style={{
                    paddingBottom: "0",
                  }}
                >
                  {formatPhoneNumber(dropOffAddress.contactPhone)}
                </Descriptions.Item>
              </Descriptions>
            )}
          </Card>
        </Col>
      </Row>
      <Row gutter={rowStyle.gutter} justify={rowStyle.justify}>
        <Col md={{ span: grid.md.span }} sm={{ span: grid.sm.span }}>
          <Card
            type="inner"
            title="Pickup Notes"
            style={cardStyle.style}
            headStyle={cardStyle.headStyle}
            className="noLeftMarginCard"
          >
            <Descriptions column={1}>
              <Descriptions.Item key="pickupAddressNotes" style={{ paddingBottom: 0 }}>
                {pickupAddress.notes}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
        <Col md={{ span: grid.md.span }} sm={{ span: grid.sm.span }}>
          <Card
            type="inner"
            title="Drop-off Notes"
            style={cardStyle.style}
            headStyle={cardStyle.headStyle}
            className="noLeftMarginCard"
          >
            <Descriptions column={1}>
              <Descriptions.Item key="dropOffAddressNotes" style={{ paddingBottom: 0 }}>
                {dropOffAddress.notes}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
      </Row>
    </>
  );
});

TransporterDetails.displayName = "TransporterDetails";

export default TransporterDetails;
